"use client";
//import Header from "../Components/Common/header.js";
import { useEffect, useState } from "react";
import { store } from "../lib/store.js";

//styles
import Logo from "../styles/img/header.svg";

//Redux
import { GetInsurance, scanToken } from "../lib/slices/paladin";
import { postStatusInsurance } from "../lib/slices/insurance.js";

//Libs
import { datadogLogs } from "@datadog/browser-logs";
import { MdCancel } from "react-icons/md";

//Hooks
import RoundLoader from "../Hooks/RoudLoader.js";

//Utils
import { isVerifiedMobileDevice } from "../Utils/deviceValidation";

//Results
import Success from "../Components/Results/Success.js";
import Error from "../Components/Results/Error.js";
import Unknown from "../Components/Results/Unknown.js";

//Components
import InvitationFail from "../Components/InvitationFail";

const Insurance = () => {
  const [loading, setLoading] = useState(false);
  const { dispatch } = store;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  const [insurance, setInsurance] = useState(null);
  const [tenantColor, setTenantColor] = useState(localStorage.getItem(`tenantColor_${token}`) || "#6A2ABD");
  const [tenantImage, setTenantImage] = useState(Logo);
  const [tenantName, setTenantName] = useState("");
  const [responseScan, setResponseScan] = useState(null);
  const [result, setResult] = useState(null);
  const [loadingResult, setLoadingResult] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const queryData = async () => {
    setLoading(true);
    var data = { token };

    try {
      const response = await dispatch(scanToken({ data }));
      const responseInsurance = await dispatch(GetInsurance({ data }));
      setResponseScan(response?.payload?.ScanToken);
      const resolvedColor = response?.payload?.ScanToken?.custom_color || "#6A2ABD";
      setTenantColor(resolvedColor);
      localStorage.setItem(`tenantColor_${token}`, resolvedColor);
      setTenantImage(
        response?.payload?.ScanToken?.custom_image &&
        `data:image/jpeg;base64,${response?.payload?.ScanToken?.custom_image}`
      );
      setTenantName(
        response?.payload?.ScanToken?.account_name
          ? response?.payload?.ScanToken?.account_name
          : ""
      );

      if (responseInsurance?.error) {
        setResult(2);
        datadogLogs.logger.log("Error to get insurance URL  (insurance)", {
          category: "error-handling",
          status: "error",
          token: token,
          errorMessage: responseInsurance,
        });
      } else {
        setInsurance(responseInsurance?.payload?.insurance);
      }

      datadogLogs.logger.log("Token validated (insurance)", {
        category: "token-validation",
        status: "info",
        tenantName: response?.payload?.ScanToken?.account_name,
      });
    } catch (error) {
      datadogLogs.logger.log(
        "Error validating token (insurance) - additional data",
        {
          category: "error-handling",
          status: "error",
          token: token,
          errorMessage: error?.message,
        }
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    queryData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleMessage = (message) => {
      if (
        message.origin === "https://ignition.sandbox.axle.insure" ||
        message.origin === "https://ignition.axle.insure"
      ) {
        switch (message.data.status) {
          case "complete":
            datadogLogs.logger.log(
              "Received completed message from Axle Ignition",
              {
                invitationId: responseScan?.invitation_id,
                status: "info",
                token: token,
                Message: message,
              }
            );
            setLoadingResult(true);
            const delay = (ms) =>
              new Promise(resolve => setTimeout(resolve, ms));

            setTimeout(async () => {
              let attempts = 0;
              const maxAttempts = 13;
              let success = false;

              const data = {
                token: token,
                status: message?.data?.status,
                authCode: message?.data?.authCode,
                client: message?.data?.client,
                result: message?.data?.result,
              };

              datadogLogs.logger.log("postStatusInsurance - timeout started", {
                status: "info",
                token,
                invitationId: responseScan?.invitation_id,
                data,
              });

              try {
                while (attempts < maxAttempts && !success) {
                  attempts++;

                  datadogLogs.logger.log("postStatusInsurance - attempt started", {
                    status: "info",
                    attempt: attempts,
                    maxAttempts,
                    token,
                    invitationId: responseScan?.invitation_id,
                  });

                  const response = await dispatch(postStatusInsurance({ data }));

                  datadogLogs.logger.log("postStatusInsurance - response received", {
                    status: "info",
                    attempt: attempts,
                    token,
                    invitationId: responseScan?.invitation_id,
                    response: response?.payload,
                  });
                  setRedirect(response?.payload?.status?.redirect || false)
                  if (response?.payload?.status?.status === 200) {
                    datadogLogs.logger.log("postStatusInsurance - success", {
                      status: "info",
                      attempt: attempts,
                      token,
                      invitationId: responseScan?.invitation_id,
                    });

                    setResult(0);
                    success = true;
                  } else {
                    datadogLogs.logger.log("postStatusInsurance - non 200 status", {
                      status: "warn",
                      attempt: attempts,
                      token,
                      invitationId: responseScan?.invitation_id,
                      responseStatus: response?.payload?.status?.status,
                    });

                    if (attempts < maxAttempts) {
                      datadogLogs.logger.log("postStatusInsurance - retry delay started", {
                        status: "info",
                        attempt: attempts,
                        delayMs: 2000,
                      });

                      await delay(2000);
                    }
                  }
                }

                if (!success) {
                  datadogLogs.logger.log("postStatusInsurance - max retries reached", {
                    status: "error",
                    attempts,
                    token,
                    invitationId: responseScan?.invitation_id,
                  });

                  setResult(2);
                }
              } catch (error) {
                datadogLogs.logger.log("postStatusInsurance - exception thrown", {
                  status: "error",
                  token,
                  invitationId: responseScan?.invitation_id,
                  error,
                });

                console.log(error);
                setResult(2);
              } finally {
                datadogLogs.logger.log("postStatusInsurance - finished", {
                  status: "info",
                  attempts,
                  success,
                  token,
                  invitationId: responseScan?.invitation_id,
                });

                setLoadingResult(false);
              }
            }, 7000);


            break;
          case "exit":
            datadogLogs.logger.log("Received exit message from Axle Ignition", {
              invitationId: responseScan?.invitation_id,
              status: "info",
              token: token,
              Message: message,
            });
            setTimeout(() => {
              setResult(1);
            }, 3000);
            break;
          case "error":
            datadogLogs.logger.log(
              "Received error message from Axle Ignition",
              {
                invitationId: responseScan?.invitation_id,
                status: "error",
                token: token,
                Message: message,
              }
            );
            setTimeout(() => {
              setResult(2);
            }, 3000);
            break;
          default:
            datadogLogs.logger.log(
              "Received unknown message from Axle Ignition",
              {
                invitationId: responseScan?.invitation_id,
                status: "info",
                token: token,
                Message: message,
              }
            );
            setTimeout(() => {
              setResult(1);
            }, 3000);
            break;
        }
      } else {
        datadogLogs.logger.log(
          "Received message from unknown origin in insurance",
          {
            status: "info",
            token: token,
            Message: message,
            invitationId: responseScan?.invitation_id,
          }
        );
        //setResult(2);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full">
      {loadingResult ? (
        <div className="flex flex-col gap-8 h-screen row-start-2 items-center justify-center w-full container mx-auto p-3 py-9">
          <RoundLoader
            loading={true}
            color={tenantColor}
            title="Analyzing"
            text="Please don’t close the browser.
                    This will take a moment."
          />
        </div>
      ) : (
        <>
          {loading ? (
            <div className="flex flex-col gap-8 h-screen row-start-2 items-center justify-center w-full container mx-auto p-3 py-9">
              <RoundLoader loading={loading} color={tenantColor} />
            </div>
          ) : (
            <>
              {responseScan?.invitation_id && (
                <>
                  {isVerifiedMobileDevice() ? (
                    <section className="flex flex-col items-center justify-start w-full">
                      {result === 0 ? (
                        <Success
                          token={token}
                          responseScan={responseScan}
                          tenantName={tenantName}
                          tenantColor={tenantColor}
                          tenantImage={tenantImage}
                          redirect={redirect}
                        />
                      ) : result === 1 ? (
                        <Unknown
                          token={token}
                          responseScan={responseScan}
                          tenantName={tenantName}
                          tenantColor={tenantColor}
                          tenantImage={tenantImage}
                        />
                      ) : result === 2 ? (
                        <Error
                          token={token}
                          responseScan={responseScan}
                          tenantName={tenantName}
                          tenantColor={tenantColor}
                          tenantImage={tenantImage}
                          redirect={redirect}
                        />
                      ) : (
                        <section className="w-full h-[85%]">
                          <iframe
                            className="w-full h-[90vh]"
                            src={insurance?.url}
                            title="Title"
                          ></iframe>
                        </section>
                      )}
                    </section>
                  ) : (
                    <div className="flex justify-center items-center min-h-screen flex-col gap-3 container px-3 py-5 bg-[#F8F7F6] w-full">
                      <MdCancel size={150} className="text-[#E43122]" />
                      <h2 className="text-2xl text-[#E43122]">Error</h2>
                      <p className="my-5 text-center text-sm">
                        PALIDIN Insurance is not available for desktop computers.{" "}
                        <br></br>
                        Please open the authentication invitation on a mobile
                        device.
                      </p>
                    </div>
                  )}
                </>
              )}
              {(responseScan?.error || token === null) && <InvitationFail />}
            </>
          )}
        </>
      )}
    </main>
  );
};

export default Insurance;
